import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedHorizon = {
    value: 3,
    label: '3',
    id: 3
};
const mock = {
    get: mockedRequester(mockedHorizon, 'horizons.get'),
    getAll: mockedRequester(mockedPaginatedResponse([mockedHorizon]), 'horizons.getAll'),
    getAllPage: mockedRequester([mockedHorizon], 'horizons.getAllPage')
};
export default mock;
